import { useContext, useEffect, useState } from "react";
import MovieContext from "../MovieContext";
import genres from "../genres";
import { BiArrowFromRight } from "react-icons/bi";
import { MdMoreHoriz } from "react-icons/md";



const Filter = () => {
  // eslint-disable-next-line
  const { setActiveGenre, activeGenre, setFiltered, movies, header } = useContext(MovieContext);

  const [moreGenres, setMoreGenres] = useState(false);
  const {
    fetchNowPlaying,
  } = useContext(MovieContext);

 useEffect(() => {
    if (activeGenre === 0) {
      setFiltered(movies);
    } else {
      const filtered = movies.filter((movie) =>
        movie.genre_ids.includes(activeGenre)
      );
      setFiltered(filtered);
    }
    // eslint-disable-next-line
  }, [activeGenre, header]);

  return (
    <div className="filter-container">
      <button
        className={activeGenre === 0 ? "active" : null}
        onClick={() => fetchNowPlaying("All")}
      >
        All
      </button>
      <button
        className={activeGenre === 28 ? "active" : null}
        onClick={() => fetchNowPlaying("thai")}
      >
        Thai
      </button>
      <button
        className={activeGenre === 14 ? "active" : null}
        onClick={() => fetchNowPlaying("adventure")}
      >
        Adventure
      </button>
      {moreGenres &&
        genres.map((genre) => (
          <button
            key={genre.id}
            className={activeGenre === genre.id ? "active" : null}
            onClick={() => fetchNowPlaying(genre.name)}
          >
            {genre.name}
          </button>
        ))}
      <button className="more" onClick={() => setMoreGenres(!moreGenres)}>
        {moreGenres ? <BiArrowFromRight /> : <MdMoreHoriz />}
      </button>
    </div>
  );
};

export default Filter;
